import { render, staticRenderFns } from "./MenuFeatured.vue?vue&type=template&id=0bfc55ac&"
import script from "./MenuFeatured.vue?vue&type=script&lang=js&"
export * from "./MenuFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports